//高级函数--7个
export const AdvancedFunc = [
  {
    "key": "if",
    "name": "if()\n{\n\n}",
    "params": [],
    "description": "If the condition is established, the content in the brackets is executed",
    "type": "Advanced",
    "keyFront": "",
    "className": ""
  },
  {
    "key": "if else",
    "name": "if()\n{\n\n}\nelse\n{\n\n}",
    "params": [],
    "description": "If the condition is established, execute the content in the brackets; otherwise execute the content in the else",
    "type": "Advanced",
    "keyFront": "",
    "className": ""
  },
  {
    "key": "for",
    "name": "for(;;)\n{\n\n}",
    "params": [],
    "description": "for loop: Example: for(var i=0;i<5;i++){}",
    "type": "Advanced",
    "keyFront": "",
    "className": ""
  },
  {
    "key": "return",
    "name": "return ;",
    "params": [],
    "description": "return value",
    "type": "Advanced",
    "keyFront": "",
    "className": ""
  },
  {
    "key": "var",
    "name": "var ",
    "params": [],
    "description": "variable definitions",
    "type": "Advanced",
    "keyFront": "",
    "className": ""
  },
  {
    "key": "true",
    "name": "true ",
    "params": [],
    "description": "true",
    "type": "Advanced",
    "keyFront": "",
    "className": ""
  },
  {
    "key": "false",
    "name": "false ",
    "params": [],
    "description": "false",
    "type": "Advanced",
    "keyFront": "",
    "className": ""
  },
  {
    "key": "Invoke",
    "name": "Invoke",
    "params": [],
    "description": "Built-in extension call function call method",
    "type": "",
    "keyFront": "DefaultExtendFunctionProxy",
    "className": ""
  }
]